import React from "react";
import Card from "../CommonComponents/Card";
import HeadLines from "../CommonComponents/HeadLines";
import style from "./style.module.css";
import timer from "./../Images/CommonImages/timer.svg";

import BookMarkComponent from "../CommonComponents/BookMarkComponent/BookMarkComponent";
import CertifiedComponent from "../CommonComponents/CertifiedComponent";
import DotComponent from "../CommonComponents/DotComponent";
import TwoLineLocation from "../MyWishlist/WishlistCard/TwoLineLocation";
import TwoLineLocationWarehouse from "./TwoLineLocationWarehouse";
import { useHistory } from "react-router";
import useUserLanguage from "../CustomHooks/useUserLanguage";
import { isMobile } from "../helperFunc";
import { titleCase } from "../CommonFunctions/Function";
const RowCSS = [
  "font-weight500 ",
  "font-weight400  line-height16 letterSpacing05 font-size14",
  "font-weight400 colorDark7 line-height14 letterSpacing025 font-size12",
  "font-weight400 colorDark7 line-height14 letterSpacing025 font-size12",
];
const deskRowCSS = [
  "font-weight500 line-height23 letterSpacing001 colorDark5 font-size20 ",
  "font-weight400  line-height19 letterSpacing05 font-size16 colorDark7 ",
  "font-weight400 colorDark7 line-height19 letterSpacing05 font-size16 padding-top8",
  "font-weight400 colorDark7 line-height19 letterSpacing05 font-size16 padding-top8",
];

const ScrollCard = ({
  data,
  className,
  isCardBottomRounded = true,
  onClick,
  showBookMark = true,
  aryaCertifiedCSS,
  bookmarked = false,
  onHeartClick,
  locationText2ClassName,
  bookMarkClass = "bookMarkPosition",
  widget = "",
  desktopAddressOneLine,
  locationText1ClassName,
  isWarehouseDesktop = false,
}) => {
  const history = useHistory();
  const userLanguage = useUserLanguage() || {};
  return (
    <div
      className={
        isMobile
          ? `margin-right8 margin-bottom16 boxRadius8 display-inline-block ${style["commonSuppliesWidth"]} ${className}`
          : `${!isWarehouseDesktop ? ` margin-right20` : `margin-right16`} ${
              style["desk-card-width"]
            } boxRadius8 display-inline-block margin-bottom16 ${className}`
      }
    >
      <Card
        className={`${
          isMobile ? `lightBorder ${style["card-width"]}` : "desk_card_border"
        } desk_card_border boxRadius8 boxShadow8 positionRelative cursor-pointer`}
        onClick={onClick}
      >
        <div className="positionRelative">
          {showBookMark && (
            <BookMarkComponent
              onClick={onHeartClick}
              bookMarked={bookmarked}
              className={` positionAbsolute ${style[bookMarkClass]}`}
            />
          )}
          {data.day && (
            <div
              className={`${style["timer-style"]} backgroundWhite positionAbsolute d-flex padding-left4 padding-right4`}
            >
              <img src={timer} alt="timer" />{" "}
              <HeadLines
                className={
                  isMobile
                    ? `${style["padding-left2"]} mtb-auto font-weight400 line-height12 letterSpacing004 font-size10 colorDark6 `
                    : `${style["padding-left2"]} font-weight400 line-height16 letterSpacing05 font-size14 colorDark9`
                }
                text={data.day}
              />
            </div>
          )}
          <img
            className={
              isMobile
                ? `${style["commonSuppliesheight"]} w-100 ${style["commonimageSuppliesWidth"]} borderRadiusTop`
                : `${style["desk-image-style"]} borderRadiusTop cursor-pointer`
            }
            src={data.image ? data.image : ""}
            onClick={() => history.push(data.url)}
            alt="arya"
            loading="lazy"
          />
        </div>

        {/* {data.noOfQuotes && (
          <div
            className={` ${style["quotesCSS"]} font-weight400 line-height14 letterSpacing025 font-size12 textColorWhite positionAbsolute padding-top4 padding-bottom4 padding-left8 padding-right8`}
          >
            {data.noOfQuotes}{" "}
            <span className={`display-inline-block`}>
              <HeadLines text="arya Certified" className=" " />
            </span>
          </div>
        )} */}

        {data.aryaCertified && (
          <CertifiedComponent
            className={` ${style["aryaCertifiedCSS"]} ${aryaCertifiedCSS} positionAbsolute padding-top4 padding-bottom4 padding-left8 padding-right8`}
            headLineClassName={
              isMobile ? "" : style["desk-arya-certified-text"]
            }
          />
        )}

        <div
          className={
            isMobile
              ? `padding-left12 padding-right12 padding-top12 backgroundWhite`
              : `padding-left12 padding-right12 padding-top16 padding-bottom16 backgroundWhite cursor-pointer`
          }
          onClick={() => history.push(data.url)}
        >
          {data?.rows[0] && (
            <>
              <HeadLines
                className={
                  isMobile
                    ? `textWrap ${RowCSS[0]} padding-bottom4 m-auto first-letter-caps `
                    : `textWrap padding-bottom8 ${deskRowCSS[0]} `
                }
                text={titleCase(data?.rows[0])}
              />
            </>
          )}
          {data?.rows[1] && (
            <>
              <DotComponent
                firstPart={data.rows[1]}
                secondPart={data?.rows[2]}
                className={[
                  `${
                    isMobile
                      ? "d-flex font-weight400 font-size12 line-height14 letterSpacing025 colorDark7 padding-bottom4 padding1"
                      : `d-flex ${deskRowCSS[1]}`
                  }`,
                  "",
                  `${isMobile ? style["dotCSS"] : style["desk-dotCSS"]}`,
                  data.noOfQuotes ? "colorAccent4" : "",
                ]}
              />
            </>
          )}
          {data?.rows[3] && (
            <>
              <HeadLines
                className={`textWrap ${
                  isMobile
                    ? "font-weight400 font-size12 line-height14  letterSpacing025 colorDark7 padding-bottom12"
                    : `${deskRowCSS[3]}`
                }`}
                text={titleCase(data?.rows[3])}
              />
            </>
          )}
        </div>

        {widget !== "warehouseNearMe" && data?.address ? (
          <TwoLineLocation
            isCardBottomRounded={isCardBottomRounded}
            locationText1={data?.address ? titleCase(data?.address) : ""}
            locationText2={data?.address2 ? titleCase(data?.address2) : ""}
            locationText2ClassName={`${locationText2ClassName}`}
            locationText1ClassName={`${
              isMobile && userLanguage?.lang_id !== "en" ? "padding-top1" : ""
            } ${!isMobile && `${style["desk-location-row"]}`}`}
            isMobile={false}
            fontSizeChangeClass={"line-height16 letterSpacing05 font-size14"}
            heightClass={15}
            widthClass={10}
          />
        ) : (
          <TwoLineLocationWarehouse
            isCardBottomRounded={isCardBottomRounded}
            locationText1={`${data?.address ? titleCase(data?.address) : ""}${
              desktopAddressOneLine ? `, ` : ""
            }`}
            locationText2={data?.address2 ? titleCase(data?.address2) : ""}
            locationText1ClassName={`${locationText1ClassName}
              ${desktopAddressOneLine && `${style["margin-right2"]}`}`}
            locationText2ClassName={`${locationText2ClassName}`}
            className={
              desktopAddressOneLine === true
                ? `d-flex padding-left12 padding-right12 padding-top8 padding-bottom8 `
                : `padding-left12 padding-right12 padding-top8 padding-bottom8`
            }
          />
        )}
      </Card>
    </div>
  );
};
export default ScrollCard;
